declare namespace $ {

	type $mol_view__sub_bog_smalljs_structure_row_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_structure_row_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_structure_row_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_structure_row_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pop_over__Anchor_bog_smalljs_structure_row_5 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure_row['Help_icon'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_bog_smalljs_structure_row_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_view__event_bog_smalljs_structure_row_7 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_smalljs_structure_row['line_click'] > ): ReturnType< $bog_smalljs_structure_row['line_click'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_smalljs_structure_row_8 = $mol_type_enforce<
		ReturnType< $bog_smalljs_structure_row['line_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_structure_row extends $mol_view {
		Prefix( ): $mol_view
		Name( ): $mol_view
		Comment( ): $mol_view
		Help_icon( ): $mol_icon_help_circle_outline
		Note( ): $mol_view
		Help( ): $mol_pop_over
		line_content( ): readonly(any)[]
		Line( ): $mol_view
		prefix( ): string
		name( ): string
		pad( ): string
		comment( ): string
		note( ): string
		kind( ): string
		active( ): boolean
		pickable( ): boolean
		pick( next?: any ): any
		line_click( next?: any ): any
		attr( ): ({ 
			'bog_smalljs_structure_kind': ReturnType< $bog_smalljs_structure_row['kind'] >,
			'bog_smalljs_structure_active': ReturnType< $bog_smalljs_structure_row['active'] >,
			'bog_smalljs_structure_pickable': ReturnType< $bog_smalljs_structure_row['pickable'] >,
		}) 
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=row.view.tree.d.ts.map